<template>
  <v-container class="pt-10">
    <v-row class="mb-6" align="center" justify="space-between">
      <v-col cols="12" md="6">
        <div style="font-family: 'montserrat-bold'; font-size: 28px; color: #193D6E;">
          {{ "Facturas" }}
        </div>
        <div style="font-family: 'montserrat-regular'; font-size: 14px;">
          Aquí puedes revisar el estatus completo de todas las facturas disponibles.
        </div>
      </v-col>

      <v-col cols="12" md="6" class="d-flex justify-end">
        <v-card
          class="py-6 px-6"
          style="background-color: #f5f5f5; border-radius: 24px; width: 100%; max-width: 550px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);"
        >
          <div class="d-flex justify-space-between align-center mb-3">
            <div style="font-family: 'montserrat-semibold'; font-size: 22px; white-space: nowrap;">Crédito utilizado</div>
            <div style="font-family: 'montserrat-semibold'; font-size: 14px; white-space: nowrap;">
              {{ "$ " + formatMoney(creditoUsado) + " USD" }} / {{ "$ " + formatMoney(creditoTotal) + " USD" }}
            </div>
          </div>

          <div style="overflow: hidden; border-radius: 100px;">
            <v-progress-linear
              :value="creditoPorcentaje"
              height="8"
              color="#0275b8"
              background-color="#dcdcdc"
              rounded
            />
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-6" align="center" justify="space-between">
      <v-col class="d-flex">
        <div style="width: 286px;">
          <v-text-field
            v-model="busqueda"
            placeholder="Buscar factura"
            clearable
            hide-details
            outlined
            style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
            prepend-inner-icon="mdi-magnify"
          />
        </div>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-end">
        <v-btn
          color="#0275b8"
          class="white--text"
          rounded
          elevation="4"
          style="text-transform: none; font-family: 'montserrat-semibold';"
          @click="dialogActivo = true"
        >
          Agregar factura
        </v-btn>
      </v-col>
    </v-row>

    <!-- <v-expansion-panels 
      multiple
      accordion
    >
      <v-expansion-panel
        v-for="(grupo, estado) in invoices"
        :key="estado"
        class="mb-4"
        style="border-radius: 15px;"
      >
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          {{ etiquetas[estado] }} ({{ grupo.length }})
        </v-expansion-panel-header>

        <v-expansion-panel-content class="px-4 pb-4 pt-1">
          <v-row
            v-for="factura in grupo"
            :key="factura.id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.id }} — {{ factura.cliente }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ factura.fecha }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: {{ formatMoney(factura.monto) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="#0275b8"
                class="white--text"
                v-if="factura.estado == 'CARGADA' || factura.estado == 'LIQUIDADA'"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="accion(factura)"
              >
                {{ accionesPorEstado[factura.estado] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels> -->

    <v-expansion-panels multiple accordion>
      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de validar ({{ invoicesPorEstado['subida']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['subida']"
            :key="factura.id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.id }} — {{ factura.cedente_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: {{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="#0275b8"
                class="white--text"
                v-if="factura.estado == 'CARGADA' || factura.estatus == 'liquidada'"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="accion(factura)"
              >
                {{ accionesPorEstado[factura.estado] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de aprobar ({{ invoicesPorEstado['validada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['validada']"
            :key="factura.id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.id }} — {{ factura.cedente_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: {{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="#0275b8"
                class="white--text"
                v-if="factura.estado == 'CARGADA' || factura.estatus == 'liquidada'"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="accion(factura)"
              >
                {{ accionesPorEstado[factura.estado] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de adelantar ({{ invoicesPorEstado['aprobada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['aprobada']"
            :key="factura.id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.id }} — {{ factura.cedente_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: {{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="#0275b8"
                class="white--text"
                v-if="factura.estado == 'CARGADA' || factura.estatus == 'liquidada'"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="accion(factura)"
              >
                {{ accionesPorEstado[factura.estado] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de cobrar ({{ invoicesPorEstado['adelantada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['adelantada']"
            :key="factura.id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.id }} — {{ factura.cedente_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: {{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="#0275b8"
                class="white--text"
                v-if="factura.estado == 'CARGADA' || factura.estatus == 'liquidada'"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="accion(factura)"
              >
                {{ accionesPorEstado[factura.estado] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de liquidar ({{ invoicesPorEstado['cobrada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['cobrada']"
            :key="factura.id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.id }} — {{ factura.cedente_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: {{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="#0275b8"
                class="white--text"
                v-if="factura.estado == 'CARGADA' || factura.estatus == 'liquidada'"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="accion(factura)"
              >
                {{ accionesPorEstado[factura.estado] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Liquidadas ({{ invoicesPorEstado['liquidada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['liquidada']"
            :key="factura.id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.id }} — {{ factura.cedente_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: {{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="#0275b8"
                class="white--text"
                v-if="factura.estado == 'CARGADA' || factura.estatus == 'liquidada'"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="accion(factura)"
              >
                {{ accionesPorEstado[factura.estado] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>
    <!-- <v-dialog
      v-model="dialogActiv"
      max-width="500"
      persistent
    >
      <v-card v-if="facturaSeleccionada">
        <v-card-title class="headline">
          {{ accionesPorEstado[facturaSeleccionada.estado] }} factura
        </v-card-title>

        <v-card-text>
          <div>
            <strong>Factura #{{ facturaSeleccionada.id }}</strong><br />
            Cliente: {{ facturaSeleccionada.cliente }}<br />
            Monto: ${{ formatMoney(facturaSeleccionada.monto) }} USD<br />
            Fecha de carga: {{ facturaSeleccionada.fecha }}
          </div>

          <v-divider class="my-4" />

          <div v-if="facturaSeleccionada.estado === 'CARGADA'">
            ¿Deseas aprobar esta factura?
          </div>

          <div v-else-if="facturaSeleccionada.estado === 'APROBADA'">
            ¿Deseas adelantar esta factura? <br />
            (Confirmará el adelanto y liberará el crédito).
          </div>

          <div v-else-if="facturaSeleccionada.estado === 'MONTO_CONFIRMADO'">
            ¿Confirmas que esta factura debe ser liquidada?
          </div>

          <div v-else-if="facturaSeleccionada.estado === 'LIQUIDADA'">
            Esta factura ya ha sido liquidada.
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogActiv = false">Cancelar</v-btn>
          <v-btn
            color="black"
            class="white--text"
            @click="confirmarAccion"
            v-if="facturaSeleccionada.estado !== 'LIQUIDADA'"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogActivo"
      max-width="600"
      persistent
    >
      <v-card>
        <v-card-title class="headline">Agregar Factura</v-card-title>

        <v-card-text>
          <v-form @submit.prevent="enviarFactura" ref="form">
            <v-text-field
              v-model="factura.numero"
              label="Número de Factura"
              required
            />
            <v-select
              v-model="factura.deudorId"
              :items="deudores"
              item-text="nombre"
              item-value="id"
              label="Cliente Deudor"
              required
            />
            <v-text-field
              v-model.number="factura.monto"
              label="Monto"
              type="number"
              required
            />
            <v-menu
              ref="menuEmision"
              v-model="menuEmision"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="factura.fechaEmision"
                  label="Fecha de Emisión"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="factura.fechaEmision" @input="menuEmision = false" />
            </v-menu>

            <v-menu
              ref="menuVencimiento"
              v-model="menuVencimiento"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="factura.fechaVencimiento"
                  label="Fecha de Vencimiento"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="factura.fechaVencimiento" @input="menuVencimiento = false" />
            </v-menu>

            <v-row dense>
              <v-col
                v-for="(archivo, index) in factura.archivos"
                :key="index"
                cols="12"
                sm="6"
                md="4"
              >
                <v-card class="pa-3 d-flex align-center justify-space-between" outlined>
                  <div class="d-flex flex-column">
                    <span style="font-weight: 600;">{{ archivo.name }}</span>
                    <span class="text--secondary text-caption">{{ (archivo.size / 1024).toFixed(1) }} KB</span>
                  </div>
                  <v-btn icon @click="eliminarArchivo(index)">
                    <v-icon color="red">mdi-close</v-icon>
                  </v-btn>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-card
                  class="pa-3 d-flex align-center justify-center"
                  outlined
                  style="cursor: pointer; border: 2px dashed #90caf9;"
                  @click="$refs.uploader.click()"
                >
                  <v-icon size="32" color="primary">mdi-plus</v-icon>
                  <span class="ml-2 font-weight-medium">Agregar documento</span>
                  <input
                    type="file"
                    accept=".pdf,.xml"
                    style="display: none"
                    ref="uploader"
                    @change="agregarArchivoManual"
                  />
                </v-card>
              </v-col>
            </v-row>

          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogActivo = false">Cancelar</v-btn>
          <v-btn color="primary" @click="">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showContract" max-width="800" persistent scrollable>
      <v-card>
        <v-card-title style="font-family: 'montserrat-bold'; font-size: 24px;">
          Contrato de Factoraje
        </v-card-title>

        <v-card-text>
          <div class="mb-4" style="font-family: 'montserrat-regular'; font-size: 15px; color: #555;">
            A continuación se presenta el contrato entre las partes para habilitar operaciones de factoraje. Por favor, revisa cuidadosamente el contenido y firma si estás de acuerdo.
          </div>

          <v-sheet
            class="grey lighten-4 px-4 py-4"
            height="300"
            style="font-family: 'montserrat-regular'; overflow-y: auto; border-radius: 12px; border: 1px solid #ddd;"
          >
            <div v-html="contractHtml"></div>
          </v-sheet>

          <div class="mt-6" style="border-top: 1px solid #ccc; padding-top: 24px;">
            <div class="mb-3" style="font-family: 'montserrat-semibold'; font-size: 16px;">
              Firmas requeridas
            </div>

            <v-row>
              <v-col cols="12" md="4" v-for="(signer, index) in signers" :key="index">
                <div style="font-family: 'montserrat-semibold';">{{ signer.label }}</div>
                <div v-if="signer.signed" style="color: green; font-family: 'montserrat-bold';">✅ Firmado</div>
                <div v-else style="color: red;">❌ Pendiente</div>
                <div style="font-size: 12px; color: #888;" v-if="signer.date">Firmado el {{ signer.date }}</div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="showContract = false"
            style="font-family: 'montserrat-semibold'; text-transform: none;"
          >
            Cerrar
          </v-btn>

          <v-btn
            color="#0075B8"
            class="white--text"
            :disabled="userAlreadySigned"
            @click="signContract"
            style="font-family: 'montserrat-semibold'; text-transform: none;"
          >
            Firmar contrato
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showTicket" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline font-weight-bold" style="font-family: 'montserrat-bold'; color: #193D6E;">
          Detalle de Liquidación
        </v-card-title>

        <v-card-text>
          <v-sheet class="pa-4" style="border: 1px dashed #ccc; border-radius: 12px; background-color: #FAFAFA;">
            <div class="text-center mb-4" style="font-family: 'montserrat-semibold'; font-size: 16px;">
              🧾 Ticket de Liquidación - {{ facturaLiqui.numero }}
            </div>

            <v-divider class="my-2" />

            <div class="d-flex justify-space-between py-1">
              <span class="text--secondary">Adelanto otorgado:</span>
              <span class="font-weight-bold">${{ formatMoney(facturaLiqui.adelanto) + " USD" }}</span>
            </div>

            <div class="d-flex justify-space-between py-1">
              <span class="text--secondary">Cobro del deudor:</span>
              <span class="font-weight-bold">${{ formatMoney(facturaLiqui.cobro) + " USD" }}</span>
            </div>

            <div class="d-flex justify-space-between py-1">
              <span class="text--secondary">Costo del financiamiento:</span>
              <span class="font-weight-bold">-${{ formatMoney(facturaLiqui.costoFinanciero) + " USD" }}</span>
            </div>

            <div v-if="facturaLiqui.moratorio > 0" class="d-flex justify-space-between py-1">
              <span class="text--secondary">Interés moratorio:</span>
              <span class="font-weight-bold">-${{ formatMoney(facturaLiqui.moratorio) + " USD" }}</span>
            </div>

            <v-divider class="my-3" />

            <div class="d-flex justify-space-between py-2">
              <span class="font-weight-bold">Total a liquidar:</span>
              <span class="font-weight-bold" style="color: #0075B8;">${{ formatMoney(facturaLiqui.totalLiquidado) + " USD" }}</span>
            </div>
          </v-sheet>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text @click="showTicket = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      nombreEmpresa: 'SFD Produce S.A.',
      creditoUsado: 500000,
      dialogActivo: false,
      dialogActiv: false,
      showTicket: false,
      showContract: false,
      creditoTotal: 1000000,
      creditoPorcentaje: 50,
      busqueda: '',
      contractHtml: `<h2 style="text-align: center; font-family: 'montserrat-bold';">Contrato de Factoraje Simplificado</h2><p style="margin-top: 20px;">Este contrato es celebrado entre las siguientes partes:</p><ul><li><strong>Proveedor:</strong> La empresa cedente de la(s) factura(s)</li><li><strong>Deudor:</strong> La empresa obligada a realizar el pago de la(s) factura(s)</li><li><strong>Administrador:</strong> La entidad que actúa como factor y opera la plataforma</li></ul><p>Mediante este contrato, el proveedor cede de manera irrevocable el derecho de cobro de ciertas facturas emitidas al deudor, a cambio de un anticipo parcial del valor de dichas facturas por parte del administrador.</p><h3 style="margin-top: 20px;">1. Línea de crédito</h3><p>El proveedor tendrá acceso a una línea de crédito de hasta <strong>$1,000,000 USD</strong> bajo el esquema de factoraje. Esta línea podrá ser utilizada mientras se cumplan los términos de este contrato.</p><h3 style="margin-top: 20px;">2. Plazo y pago</h3><p>El deudor se compromete a realizar el pago de las facturas cedidas en un plazo de <strong>30 días naturales</strong> contados a partir de la fecha de emisión de cada factura.</p><h3 style="margin-top: 20px;">3. Tasa de interés y comisión</h3><p>El administrador aplicará una <strong>tasa de interés mensual del 2.5%</strong> sobre el monto financiado. Esta tasa será prorrateada según el número de días del crédito utilizado.</p><h3 style="margin-top: 20px;">4. Adelanto</h3><p>El proveedor podrá recibir un adelanto de hasta el <strong>80% del valor de la factura</strong> al momento de su aprobación. El 20% restante será entregado al liquidarse la factura por parte del deudor.</p><h3 style="margin-top: 20px;">5. Penalizaciones por mora</h3><p>En caso de que el deudor no cumpla con el pago en el plazo acordado (30 días), se aplicará una penalización por mora equivalente a <strong>2.5% por día de retraso</strong> sobre el monto pendiente.</p><h3 style="margin-top: 20px;">6. Cesión irrevocable</h3><p>El deudor reconoce que los pagos deben realizarse directamente al administrador, y no al proveedor, liberando así al proveedor de cualquier responsabilidad de cobro.</p><h3 style="margin-top: 20px;">7. Aceptación</h3><p>Este contrato entra en vigor una vez que las tres partes (Proveedor, Deudor y Administrador) hayan firmado digitalmente el presente documento.</p><p style="margin-top: 30px;">La firma de este contrato implica la aceptación total de los términos aquí establecidos.</p>`,
      userRole: 'proveedor', // puede ser 'proveedor', 'deudor', 'admin'
      signers: [
        { label: 'Mezna Produce', signed: false, date: null, role: 'proveedor' },
        { label: 'Perlag Imports', signed: false, date: null, role: 'deudor' },
        { label: 'Fresher Pay', signed: false, date: null, role: 'admin' }
      ],
      invoices: [],
      facturaLiqui: {
        numero: 'FAC-1021',
        adelanto: 5000,
        cobro: 6000,
        costoFinanciero: 800,
        moratorio: 100,
        totalLiquidado: 100 // (6000 - 800 - 100)
      },
      etiquetas: {
        CARGADA: 'Pendientes de aprobación',
        APROBADA: 'Pendientes de adelantar',
        COBRO_PENDIENTE: 'Pendientes de cobrar',
        MONTO_CONFIRMADO: 'Pendientes de liquidar',
        LIQUIDADA: 'Liquidadas'
      },
      accionesPorEstado: {
        CARGADA: 'Aprobar',
        APROBADA: 'Adelantar',
        COBRO_PENDIENTE: 'Registrar cobro',
        MONTO_CONFIRMADO: 'Liquidar',
        LIQUIDADA: 'Ver detalle'
      },
      deudores: [
        { id: 1, nombre: 'Cliente A' },
        { id: 2, nombre: 'Cliente B' },
      ],
      busqueda: '',
      facturaSeleccionada: null,
      dialogActivo: false,
      factura: {
        numero: "",
        deudorId: null,
        monto: null,
        fechaEmision: null,
        fechaVencimiento: null,
        archivos: []
      },
      menuEmision: false,
      menuVencimiento: false
    };
  },
  computed: {
    facturasFiltradas() {
      if (!this.busqueda) return this.facturas;
      const query = this.busqueda.toLowerCase();
      return this.facturas.filter(f =>
        String(f.id).includes(query) ||
        f.fecha.toLowerCase().includes(query) ||
        String(f.monto).includes(query)
      );
    },
    invoicesPorEstado() {
      if (!Array.isArray(this.invoices)) return {};  // 🔍 Valida que sea un array

      return this.invoices.reduce((acc, factura) => {
        const estado = factura.estatus || 'SIN_ESTADO';
        if (!acc[estado]) {
          acc[estado] = [];
        }
        acc[estado].push(factura);
        return acc;
      }, {});
    },
    userAlreadySigned() {
      const current = this.signers.find(s => s.role === this.userRole);
      return current?.signed;
    },
    // facturasPorEstado() {
    //   return this.facturasFiltradas.reduce((acc, factura) => {
    //     if (!acc[factura.estado]) acc[factura.estado] = [];
    //     acc[factura.estado].push(factura);
    //     return acc;
    //   }, {});
    // }
  },
  methods: {
    async getInvoices() {
      try {
        this.isLoading = true;
        const response = await DB.get(`${URI}/api/v1/en/factoringInvoices/cedente/${this.$route.params.empresaId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.invoices = response.data.factoringInvoices || [];
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    accion(factura) {
      this.facturaSeleccionada = factura
      this.dialogActiv = true
    },
    signContract() {
      const signer = this.signers.find(s => s.role === this.userRole);
      if (signer) {
        signer.signed = true;
        signer.date = new Date().toLocaleDateString();
      }
    },
    agregarArchivoManual(event) {
      const archivo = event.target.files[0];
      if (archivo) {
        this.factura.archivos.push(archivo);
      }
      // resetear input para poder volver a subir el mismo archivo si lo desea
      event.target.value = null;
    },
    eliminarArchivo(index) {
      this.factura.archivos.splice(index, 1);
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    abrirDetalle(factura) {
      this.$router.push({
        name: 'FacturaDetalleAssignor',
        params: { id: factura.id }
      });
    },
    confirmarAccion() {
      const estado = this.facturaSeleccionada.estado
      const id = this.facturaSeleccionada.id


      this.dialogActiv = false
    }
  },
  beforeMount() {
    this.getInvoices();
  },
};
</script>

<style>
  .v-expansion-panel:not(:first-child)::after {
    border-top: none !important;
  }
</style>